import { AlertCircle } from 'lucide-react'
import { cn } from '@/lib/utils'

export interface RunErrorProps {
  /** Error message */
  error?: string
  /** Additional CSS classes */
  className?: string
}

/**
 * Error message display with styling.
 * 
 * @example
 * ```tsx
 * <RunError error={run.error_message} />
 * ```
 */
export function RunError({ error, className }: RunErrorProps) {
  if (!error) {
    return null
  }

  return (
    <div
      className={cn(
        'flex items-start gap-3 p-4 rounded-lg bg-red-50 border border-red-200 text-red-800',
        className
      )}
    >
      <AlertCircle className="h-5 w-5 text-red-500 flex-shrink-0 mt-0.5" />
      <div className="flex-1">
        <p className="font-medium">Run Failed</p>
        <p className="text-sm mt-1 text-red-700">{error}</p>
      </div>
    </div>
  )
}
